export default __webpack_public_path__ + "static/media/3.716f8465.jpeg";